import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store/index';
// import Home from './views/Home.vue';
import Login from '../views/Login/Login';
import Trips from '../views/Trips';
import UserProfile from '../components/Users/UserProfile';
import ExcelUpload from '../components/Excel/ExcelUpload';
import NewTrip from '../components/NewTrip';
import SignUp from '../views/Login/SignUp';
import PrivacyPolicy from '../views/anonymous/PrivacyPolicy';
import TermsAndConditions from '../views/anonymous/TermsAndConditions';
import ResetPassword from '../views/Login/ResetPassword';
import Company from '../views/Company.vue';
import JoinCompany from '../components/Company/JoinCompany';
import JoinTrip from '../components/CurrentTrip/JoinTrip';
import CompanyTrips from '../components/Company/CompanyTrips';
import trip from "./trip";
import Home from "../views/Home";

console.log("init router.js");
Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
    },
  },
  trip,
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      isForLogin: true,
    },
  },
  {
    path: '/signup',
    name: 'SignUp',
    component: SignUp,
    meta: {
      isForLogin: true,
    },
  },
  {
    path: '/trips/:index',
    name: 'MyCompanyTrips',
    component: Trips,
    props: true,
    beforeEnter: ((to, from, next) => {
      if (to.params.companyId) {
        next();
      } else {
        next({ name: 'Trips' });
      }
    }),
  },
  {
    path: '/trips',
    name: 'Trips',
    component: Trips,
  },
  {
    path: '/profile',
    name: 'user_profile',
    component: UserProfile,
  },
  {
    path: '/password_reset',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: {
      isAnonymus: true,
    },

  },
  {
    path: '/join_company',
    name: 'JoinCompany',
    component: JoinCompany,
  },
  {
    path: '/company-trips/:index',
    name: 'CompanyTrips',
    component: CompanyTrips,
    props: true,
    beforeEnter: ((to, from, next) => {
      if (to.params.companyId) {
        next();
      } else {
        next({ name: 'Trips' });
      }
    }),
  },
  {
    path: '/company/:index',
    name: 'Company',
    component: Company,
    props: true,
    beforeEnter: ((to, from, next) => {
      if (to.params.companyId) {
        next();
      } else {
        next({ name: 'Trips' });
      }
    }),
  },
  {
    path: '/upload',
    name: 'ExcelUpload',
    component: ExcelUpload,
  },
  {
    path: '/newtrip',
    name: 'NewTrip',
    component: NewTrip,
  },
  {
    path: '/join_trip',
    name: 'JoinTrip',
    component: JoinTrip,
  },
  {
    path: '/join-trip',
    name: 'JoinATrip',
    component: JoinTrip,
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  }, {
    path: '/privacy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
    meta: {
      isAnonymus: true,
    },
  }, {
    path: '/terms-and-conditions',
    name: 'TermsAndConditions',
    component: TermsAndConditions,
    meta: {
      isAnonymus: true,
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});
router.beforeEach((to, from, next) => {
  // check to see if route requires auth
  if (to.matched.some((rec) => rec.meta.isAnonymus)) {
    console.log('is anonymus, going next');
    next();
  } else if (to.matched.some((rec) => rec.meta.isForLogin)) {
    console.log('isForLogin');
    const user = store.state.firUser;
    if (user) {
      console.log('redirecting to trips');
      next({ name: 'Trips' });
    } else {
      next();
    }
  } else {
    // check auth state of user
    const user = store.state.firUser;
    if (user) {
      next();
    } else {
      console.log(to);
      if (to.path !== "/") {
        console.log(`saving path ${to.path}`);
        router.startUrl = to.fullPath;
      }

      next({ name: 'Login', params: to.query });
    }
  }
});

export default router;
